var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100,50 C100,22.3857422 77.6142578,0 50,0 C22.3857422,0 0,22.3857422 0,50 C0,74.9564453 18.2842773,95.6416016 42.1875,99.3925781 L42.1875,64.453125 L29.4921875,64.453125 L29.4921875,50 L42.1875,50 L42.1875,38.984375 C42.1875,26.453125 49.6521484,19.53125 61.0732422,19.53125 C66.5436523,19.53125 72.265625,20.5078125 72.265625,20.5078125 L72.265625,32.8125 L65.9607422,32.8125 C59.7495117,32.8125 57.8125,36.6666992 57.8125,40.6208008 L57.8125,50 L71.6796875,50 L69.4628906,64.453125 L57.8125,64.453125 L57.8125,99.3925781 C81.7157227,95.6416016 100,74.9564453 100,50",
    id: "Fill-1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonFacebook);
export default __webpack_public_path__ + "static/media/button-facebook.7a393743.svg";
export { ForwardRef as ReactComponent };